<template>
  <div class="cityList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入城市名称" size="small" v-model="cityParam.city" class="param-input" @keyup.enter.native="getCityList()"></el-input>
      <el-button type="primary" size="small" @click="getCityList()">搜索</el-button>
    </div>
    <!--数据表格-->
    <el-table height="630" :data="tableData" style="width: 100%" border ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" @sort-change="handleSortChange">
      <el-table-column prop="id" label="ID" align="center" width="250">
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="city" label="城市" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.city || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cover" label="背景图" align="center">
        <template slot-scope="scope">
          <img-load :width="'70px'" :height="'90px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>

      <el-table-column prop="videoCount" label="视频数" align="center">
        <template slot-scope="scope">
          <span>{{(scope.row.videoCount  || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="visit" label="访问量(真)" align="center" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{(scope.row.visit || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fakeVisit" label="访问量(假)" align="center">
        <template slot-scope="scope">
          <span>{{(scope.row.fakeVisit || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="collectCount" label="收藏数" align="center">
        <template slot-scope="scope">
          <span>{{(scope.row.collectCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="playCount" label="总播放数" align="center">
        <template slot-scope="scope">
          <span>{{(scope.row.playCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="effectivePlayRate" label="有效播放率" align="center">
        <template slot-scope="scope">
          <span>{{('无字段' || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortKey" label="排序" align="center" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{scope.row.sortKey || '0'}}</span>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="createdAt" label="添加时间" align="center" width="160">
        <template slot-scope="scope">
          <span> {{scope.row.createdAt  | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button type="success" size="mini" class="el-icon-edit" @click="tagsAction('edit',scope.row)"></el-button>
          <!-- <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.vid)"></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 15, 20, 30]" :current-page="cityParam.pageNumber" :page-size="cityParam.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 5" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑tag弹窗-->
    <tag-action ref="tagAction" @handlerCityList="getCityList()"></tag-action>
  </div>
</template>
<script>
import TagAction from './components/addTag'
import API from '@/api'
import { sortEscape } from '@/utils/global'
import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      loading: false,
      total: 0,
      tableData: [],
      imgUrl: baseConfig.imgUrl,
      cityParam: {
        pageNumber: 1,
        pageSize: 5,
        key: '',
        value: '',
        city: ''
      }
    }
  },
  components: {
    TagAction
  },
  created() {
    this.getCityList()
  },
  methods: {
    // 获取城市列表
    getCityList() {
      this.loading = true
      API.getCityList(this.cityParam).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.loading = false
      })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.cityParam.pageSize = size
      this.cityParam.pageNumber = 1
      this.getCityList(this.cityParam)
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.cityParam.pageNumber = pageNumber
      this.getCityList(this.cityParam)
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.cityParam.value = sortEscape(column.order)
        this.cityParam.key = column.prop;
      } else {
        this.cityParam.value = ''
        this.cityParam.key = '';
      }
      this.getCityList(this.cityParam)
    },
    // 新增、删除tags
    tagsAction(type, data) {
      this.$refs.tagAction.open(type, data)
    }
  }
}
</script>
